exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".htqzO{text-align:center}.gaZK5{background-color:#222;padding:10px;color:#fff;font-size:20pt}._1ppWy{font-size:15pt}", ""]);

// exports
exports.locals = {
	"root": "htqzO",
	"header": "gaZK5",
	"intro": "_1ppWy"
};